import { render, staticRenderFns } from "./requireview.vue?vue&type=template&id=6f39b4a9&scoped=true&"
import script from "./requireview.vue?vue&type=script&lang=js&"
export * from "./requireview.vue?vue&type=script&lang=js&"
import style0 from "./requireview.vue?vue&type=style&index=0&id=6f39b4a9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f39b4a9",
  null
  
)

export default component.exports